(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["im-main-collection"]) return;
  try {
    
  if (!customElements.get('metal-sticker-search')) {
    customElements.define(
      'metal-sticker-search',
      class MetalStickerSearch extends HTMLElement {
        connectedCallback() {
          this.input = this.querySelector('input[name="q"]');
          this.form = this.querySelector('form');
          this.results = this.querySelector('.im-sticker-search__results');
          this.items = this.querySelector('.im-sticker-search__items');
          this.closeButton = this.querySelector('.im-sticker-search__close');
          this.allResults = this.querySelector('.im-sticker-search__all');
          this.timer = null;
          this.controller = null;
          document.documentElement.classList.add('im-sticker-collection');
          this.suppressCodOverlays();
          this.codObserver = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
              mutation.addedNodes.forEach((node) => {
                if (node.nodeType === Node.ELEMENT_NODE) this.suppressCodOverlays(node);
              });
            });
          });
          this.codObserver.observe(document.body, { childList: true, subtree: true });

          this.input.addEventListener('input', () => {
            window.clearTimeout(this.timer);
            const term = this.input.value.trim();

            if (term.length < 2) {
              this.close();
              return;
            }

            this.timer = window.setTimeout(() => this.search(term), 220);
          });

          this.form.addEventListener('submit', () => {
            const term = this.input.value.trim();
            if (term && !term.toLowerCase().includes('metal sticker')) {
              this.input.value = term + ' "Metal Sticker"';
            }
          });

          this.closeButton.addEventListener('click', () => {
            this.close();
            this.input.focus();
          });

          document.addEventListener('click', (event) => {
            if (!this.contains(event.target)) this.close();
          });
        }

        disconnectedCallback() {
          if (this.codObserver) this.codObserver.disconnect();
          document.documentElement.classList.remove('im-sticker-collection');
        }

        async search(term) {
          if (this.controller) this.controller.abort();
          this.controller = new AbortController();

          const params = new URLSearchParams({
            q: term,
            'resources[type]': 'product',
            'resources[limit]': '6',
            'resources[options][fields]': 'title,product_type,tag'
          });

          try {
            const response = await fetch('/search/suggest.json?' + params.toString(), {
              signal: this.controller.signal
            });
            if (!response.ok) throw new Error('Search request failed');

            const payload = await response.json();
            const products = (payload.resources?.results?.products || []).filter((product) => {
              return product.title.toLowerCase().includes('metal sticker') ||
                product.type?.toLowerCase() === 'metal sticker';
            });

            this.render(products, term);
          } catch (error) {
            if (error.name !== 'AbortError') this.close();
          }
        }

        render(products, term) {
          if (!products.length) {
            this.items.innerHTML = '<p class="im-sticker-search__empty">No matching metal stickers found. Try another name or style.</p>';
            this.allResults.hidden = true;
          } else {
            this.items.innerHTML = products.map((product) => {
              const image = product.image
                ? '<img src="' + this.escape(product.image) + '&width=124" alt="" width="62" height="62" loading="lazy">'
                : '<span></span>';
              return '<a class="im-sticker-search__result" role="option" href="' + this.escape(product.url) + '">' +
                image +
                '<span class="im-sticker-search__result-title">' + this.escape(product.title) + '</span>' +
                '<span class="im-sticker-search__result-price">' + this.escape(product.price) + '</span>' +
                '</a>';
            }).join('');
            this.allResults.hidden = false;
            this.allResults.href = '/search?q=' + encodeURIComponent(term + ' "Metal Sticker"') + '&type=product';
          }

          this.results.hidden = false;
          this.classList.add('is-open');
          this.input.setAttribute('aria-expanded', 'true');
        }

        close() {
          this.results.hidden = true;
          this.items.innerHTML = '';
          this.classList.remove('is-open');
          this.input.setAttribute('aria-expanded', 'false');
        }

        suppressCodOverlays(root = document) {
          const selectors = [
            '[id*="releasit" i]',
            '[class*="releasit" i]',
            '[id*="cod-form" i]',
            '[class*="cod-form" i]',
            '[id*="rsi-cod" i]',
            '[class*="rsi-cod" i]',
            'iframe[src*="releasit" i]'
          ].join(',');

          if (root.matches && root.matches(selectors)) {
            root.style.setProperty('display', 'none', 'important');
            root.setAttribute('data-im-search-suppressed', 'true');
          }

          if (root.querySelectorAll) {
            root.querySelectorAll(selectors).forEach((element) => {
              element.style.setProperty('display', 'none', 'important');
              element.setAttribute('data-im-search-suppressed', 'true');
            });
          }
        }

        escape(value) {
          const element = document.createElement('div');
          element.textContent = value || '';
          return element.innerHTML;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
